<!--
 * @description: 左下悬浮窗
 * @Author: Jay
 * @Date: 2021-10-07 14:21:24
 * @LastEditors: Jay
 * @LastEditTime: 2022-02-14 10:42:30
-->
<template>
  <div>
    <!-- 浮窗 -->
    <div class="location" id="searchBar">
      <div v-class="'animate__animated animate__fadeInUp'" v-if="ifShow">
        <div class="right-code">
          <!-- 顶部半圆 -->
          <div class="top-circle"></div>
          <!-- 居中内容 -->
          <div class="code-center">
            <div v-for="(item, index) in rightdata" :key="index">
              <!-- 淘宝 -->
              <el-image
                class="image"
                :src="item.img"
                fit="fill"
                :lazy="true"
                @click="selectTap(index)"
              ></el-image>
              <!-- 分割线 -->
              <div class="code-line" v-show="index != 2"></div>
            </div>
          </div>
          <!-- 底部半圆 -->
          <div class="bottom-circle"></div>
        </div>
      </div>
    </div>
    <!-- 二维码弹窗 -->
    <el-dialog
      title="扫码关注"
      :visible.sync="QRShow"
      width="20%"
      :before-close="handleClose"
      center
      v-if="usData != ''"
    >
      <el-image
        :src="$api + usData[1].value"
        fit="fill"
        :lazy="true"
      ></el-image>
    </el-dialog>
  </div>
</template>

<script>
import { getKefu } from "../../api/api";
export default {
  name: "RightBottom",
  data() {
    return {
      //是否显示
      ifShow: false,
      rightdata: [
        {
          img: "https://img1.baidu.com/it/u=1813780593,1696772717&fm=26&fmt=auto",
        },
        {
          img: require("../../assets/right-bottom/tight-bot-qr.png"),
        },
        {
          img: require("../../assets/right-bottom/tight-bot-qq.png"),
        },
      ],
      //是否显示二维码弹窗
      QRShow: false,
      //请求数据
      usData: [],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      //联系客服
      getKefu().then((res) => {
        // console.log(res);
        this.usData = res.data;
      });
    },
    //滑动到一定位置显示
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector("#searchBar").offsetTop;
      if (scrollTop > offsetTop) {
        this.ifShow = true;
      } else {
        this.ifShow = false;
      }
      //   console.log(scrollTop, offsetTop);
    },
    //点击
    selectTap(index) {
      // console.log(index);
      switch (index) {
        case 0:
          //跳转淘宝
          // window.location.href = this.usData[0].value;
          window.open(this.usData[0].value);
          break;
        case 1:
          //二维码
          this.QRShow = true;
          break;
        case 2:
          //复制qq
          this.copy(this.usData[2].value);
          //打开qq 加好友
          setTimeout(() => {
            window.open(
              "http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin=" +
                this.usData[2].value
            );
          }, 800);

          break;
      }
    },
    //复制
    copy(url) {
      // 创建一个 Input标签
      const cInput = document.createElement("input");
      cInput.value = url;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      //提示
      this.$message({
        message: "复制成功-打开QQ-添加好友",
        type: "success",
      });
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },
    // 关闭弹窗
    handleClose(done) {
      done();
      //   this.$confirm("确认关闭？")
      //     .then((_) => {
      //       done();
      //     })
      //     .catch((_) => {});
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.location {
  position: fixed;
  right: 50px;
  bottom: 120px;
  z-index: 99;
}

.right-code {
  // background-color: #ffcc00;
  background-color: #333;
  border-radius: 60px;
  width: 80px;
  height: 260px;
  //   z-index: 1111;
  position: relative;
}

//居中内容
.code-center {
  padding: 63px 20px;
}
.image {
  width: 40px;
  height: 36px;
  border-radius: 10px;
}
//分割线
.code-line {
  width: 40px;
  height: 1px;
  // background-color: #333;
  background-color: #fff;
  margin: 5px 0;
}

//左边线条
.right-code:before {
  content: " ";
  position: absolute;
  top: 25%;
  left: 10px;
  height: 130px;
  width: 4px;
  border-radius: 40px;
  // background-color: #333;
  background-color: #fff;
}
//右边线条
.right-code:after {
  content: " ";
  position: absolute;
  top: 25%;
  right: 10px;
  height: 130px;
  width: 4px;
  border-radius: 40px;
  // background-color: #333;
  background-color: #fff;
}

// 顶部半圆
.top-circle {
  position: absolute;
  top: 8px;
  left: 10px;
  // background-color: #333;
  background-color: #fff;
  width: 60px;
  height: 50px;
  border-radius: 55px 55px 10px 10px;
}
// 底部半圆
.bottom-circle {
  position: absolute;
  bottom: 8px;
  left: 10px;
  // background-color: #333;
  background-color: #fff;
  width: 60px;
  height: 50px;
  border-radius: 10px 10px 55px 55px;
}
</style>
